module.exports = __webpack_public_path__ + "static/media/43.81aece03.svg";